import type { BasketViewModel } from 'autogen/swagger/all';
import Layout from 'components/Layout';
import styled from 'styled-components';
import { Spacing32 } from 'autogen/design-tokens/tokens';
import { breakpoint, sizes } from 'variables';
import format from 'helpers/translations';
import TrackingContext from 'modules/tracking/GA4/helpers/TrackingContext';
import { hideOnMobile } from '../Checkout/components/Delivery/shared/styles';
import Basket from './components/Basket';
import BasketRecommendation from './components/BasketRecommendation/BasketRecommendation';
import AntiBreakQuickView from './components/AntiBreakQuickView';
import { useQuickView } from 'components/quickView';
import { useEffect } from 'react';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';

const CustomContentLayout = styled.div`
    display: grid;
    gap: ${Spacing32};

    ${breakpoint.up(sizes.lg)} {
        grid-template-columns: 3fr 1fr;
    }
`;

export default function BasketPage({ model }: { model: BasketViewModel }) {
    const { usp, showRecommendations, deliveryFixViewModel } = model;
    const { toggle } = useQuickView('antiBreakQuickView');

    useEffect(() => {
        if (deliveryFixViewModel?.isOpen) {
            toggle(true);
            GA4Tracking({
                eventName: 'open_modal',
                context: 'basket',
                category: 'ecommerce',
                eventParams: [
                    {
                        param_name: 'modal_type',
                        param_value: 'anti_break'
                    },
                    {
                        param_name: 'trigger_origin',
                        param_value: 'go_to_basket'
                    }
                ]
            });
        }
    }, []);

    return (
        <>
            <TrackingContext context="basket">
                <Layout.Page>
                    <Layout.Section
                        contentRenderer={(children) => <CustomContentLayout>{children}</CustomContentLayout>}
                    >
                        <Layout.Flex.Column>
                            <Basket model={model} />
                            {showRecommendations && <BasketRecommendation />}
                        </Layout.Flex.Column>

                        <Layout.Flex.Column css={hideOnMobile}>
                            {usp && <div style={{ display: 'contents' }}>{format(usp)}</div>}
                        </Layout.Flex.Column>
                    </Layout.Section>
                </Layout.Page>
            </TrackingContext>

            {deliveryFixViewModel && <AntiBreakQuickView model={deliveryFixViewModel} />}
        </>
    );
}
